import React from "react";
import Text from "../../../../../_components/Text";
import Button from "../../../../../_components/Button";
import IconButton from "../../../../../_components/IconButton";
import Modal from "../../../../../_components/Modal";
import { getBranchInvoices, getIugu } from "../../../../../api/plans";
import { Table, FormControl } from "react-bootstrap";
import { formatCurrencyValue, formatPhoneNumber } from "../../../../../utils";
import * as colors from "../../../../../assets/_base/colors";
import styled from "styled-components";
import { showSnackBar } from "../../../../../utils";
import AppContext from "../../../context";

const Sync = styled.div`
  display: flex;
  margin-top: 10px;
  > .text,
  .icon {
    font-size: 11px;
    padding-right: 5px;
  }
`;

export default (props) => {
  const ref = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const context = React.useContext(AppContext);
  const [invoices, setInvoices] = React.useState([]);
  const [show, setShow] = React.useState(false);
  const [invoice, setInvoice] = React.useState({});
  const [filteresInvoices, FilterInvoices] = React.useState([]);

  function iugu(id) {
    setLoading(true);
    getIugu(id).finally(() => {
      window.location.reload();
    });
  }

  function copyPIXCode(code) {
    const el = document.createElement("textarea");
    el.value = code;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selecionado =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    showSnackBar("PIX Copiado", "info");
    if (selecionado) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selecionado);
    }
  }

  function navigate() {
    window.location.href = "/settings/branch";
  }

  function viewInvoice(e) {
    if (e.status === 1) {
      setInvoice(e);
      setShow(true);
      if (e.pix_qr_text) {
        copyPIXCode(e.pix_qr_text);
      }
    } else {
      window.open(e.invoice_url, "__blank");
    }
  }
  function closeModal() {
    setShow(false);
    setInvoice({});
  }

  function getInstatusColors(invoice) {
    const statusColors = {
      1: {
        color: colors.yellow,
        text: "Pendente",
      },
      2: {
        color: colors.success,
        text: "Pago",
      },
      3: {
        color: colors.danger,
        text: "Cancelado",
      },
      4: {
        color: "#7f8c8d",
        text: "Expirado",
      },
    };
    const TD = styled.td`
      background-color: ${statusColors[invoice.status].color};
      color: ${colors.light};
    `;
    return (
      <TD>
        <strong>{statusColors[invoice.status].text}</strong>
      </TD>
    );
  }
  function filter(e) {
    const { value: status } = e.target;
    if (status == "-") {
      FilterInvoices(invoices);
    } else {
      FilterInvoices(invoices.filter((i) => i.status == status));
    }
  }

  React.useEffect(() => {
    getBranchInvoices().then((resp) => {
      setInvoices(resp);
      FilterInvoices(resp);
    });
  }, [ref.current]);

  return (
    <div className="container" ref={ref}>
      <div className="row">
        <div className="col-12">
          <Text as="h1">Faturas</Text>
        </div>
        <div className="col-4 mb-3">
          <Text className="p-0 m-0">Filtar por status</Text>
          <FormControl onChange={filter} as="select">
            <option value="-" selected>
              Todas
            </option>
            <option value="1">Pendente</option>
            <option value="2">Pago</option>
            <option value="3">Cancelado</option>
            <option value="4">Expirado</option>
          </FormControl>
        </div>
        <div className="col-12">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Cód.</th>
                <th>Vencimento</th>
                <th>Descrição</th>
                <th>Situação</th>
                <th>Valor</th>
                <th>Comprovante</th>
              </tr>
            </thead>
            <tbody>
              {filteresInvoices.map((invoice) => {
                invoice.total_amount = formatCurrencyValue(
                  invoice.total_amount
                );
                return (
                  <tr>
                    <td>
                      {invoice.status == 1 ? (
                        <Sync>
                          <IconButton
                            disabled={loading}
                            onClick={() => iugu(invoice.id)}
                            className="icon"
                            icon="sync"
                          />
                          <Text color="primary">{invoice.code}</Text>
                        </Sync>
                      ) : (
                        <Text color="primary">{invoice.code}</Text>
                      )}
                    </td>
                    <td>
                      <strong>{invoice.due_date}</strong>
                    </td>
                    <td>
                      <strong>{invoice.description}</strong>
                    </td>
                    {getInstatusColors(invoice)}
                    <td>
                      <strong>{invoice.total_amount}</strong>
                    </td>
                    <td className="p-0 m-0">
                      <Button onClick={() => viewInvoice(invoice)}>
                        {invoice.status === 2
                          ? "Comprovante"
                          : "Visualizar Fatura"}
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className="col-md-12 py-3">
          <Text>
            Lembrete de cobrança será enviado para o email
            {context.currentBranch.email} e ao telefone{" "}
            {formatPhoneNumber(context.currentBranch.phone_number)}
          </Text>
        </div>
        <div className="col-md-12 py-3">
          <Text>
            Para atualizar os endereços de cobrança, por favor,{" "}
            <Button onClick={navigate} as="text">
              atualize as informações da empresa.
            </Button>
          </Text>
        </div>
      </div>

      <Modal title={invoice.description} show={show} onHide={closeModal}>
        <Text className="text-center" as="h2">
          {invoice.total_amount}
        </Text>
        <Text className="text-center" as="h3">
          {invoice.description}
        </Text>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            style={{ maxWidth: 250 }}
            src={invoice.pix_url}
            alt={invoice.pix_qr_text}
          />
        </div>
        <div className="flex">
          <Text as="h5">
            {invoice.pix_qr_text}{" "}
            <i
              title="Copiar Código PIX"
              onClick={() => copyPIXCode(invoice.pix_qr_text)}
              style={{ cursor: "pointer" }}
              className="fas fa-copy"
            />
          </Text>
        </div>
        <Button onClick={() => window.open(invoice.invoice_url, "__blank")}>
          Visualizar Fatura
        </Button>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/BranchPlan/Invoices/index.jsx